/* tslint:disable */
import * as Types from '../../../../../../graphql-api/baskets-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { DataBasketsModule } from '../data-baskets.module';
export type SearchBasketsQueryVariables = Types.Exact<{
  num?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  start?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sortBy?: Types.InputMaybe<Types.BasketSearchSortType>;
  sortDirection?: Types.InputMaybe<Types.BasketSearchSortDirection>;
  statuses?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
}>;


export type SearchBasketsQuery = { searchBaskets?: { totalResultCount?: number | null, baskets?: Array<{ basketId: string, orderReferenceNumber: string } | null> | null } | null };

export const SearchBasketsDocument = gql`
    query SearchBaskets($num: Int, $start: Int, $sortBy: BasketSearchSortType, $sortDirection: BasketSearchSortDirection, $statuses: [Int!]) {
  searchBaskets(
    num: $num
    start: $start
    sortBy: $sortBy
    sortDirection: $sortDirection
    statuses: $statuses
  ) {
    totalResultCount
    baskets {
      basketId
      orderReferenceNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: DataBasketsModule
  })
  export class SearchBasketsGQL extends Apollo.Query<SearchBasketsQuery, SearchBasketsQueryVariables> {
    document = SearchBasketsDocument;
    client = 'baskets';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }